function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 19.5h44.7v7.8H6v36.9h60.2V4H6v15.5zm44.7 29.2H21.5v-7.8h29.1v7.8zM87.6 4H72v60.2h60.2V48.7H87.6zM72 85.6h44.7v7.8H72v36.9h60.2V70H72v15.6zm44.7 31H87.6v-7.8h29.1v7.8zM6 130.2h13.6V85.6h7.8v44.6h15.5V85.6h7.8v44.6h15.5V70H6zM423.5 72v5.8h21.4v52.4h7.7V77.8H474V72zM218.5 70l-27 60.2h7.3l6.9-15.5H238l6.9 15.5h7.2l-27-60.2h-6.6zm-9.6 38.9l13-29.4 12.9 29.4h-25.9zM268.2 72h-7.8v58.2h40.8v-5.8h-33zM408 118.9L369.1 70h-5.8v60.2h7.8V83.3l37.9 46.9h6.7V70H408zM310.9 130.2h42.7v-5.8h-35V105h33.1v-7.8h-33.1V77.8h35V72h-42.7zM198.2 72h-50.4v5.8h21.3v52.4h7.8V77.8h21.3z"
});

var SvgAlmaTalentLogo = function SvgAlmaTalentLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 480 135",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAlmaTalentLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alma_talent_logo.38247b18.svg";
export { ForwardRef as ReactComponent };